import registerReduxModal from 'components/common/hoc/registerReduxModal'
import BenefitsModal from './BenefitsModal'
import { BENEFITS_MODAL } from './constants'

export default registerReduxModal({ name: BENEFITS_MODAL })(BenefitsModal)

export {
  BENEFITS_MODAL
}
